import { render, staticRenderFns } from "./ChatImagePreview.vue?vue&type=template&id=287e0f14&scoped=true"
import script from "./ChatImagePreview.vue?vue&type=script&lang=js"
export * from "./ChatImagePreview.vue?vue&type=script&lang=js"
import style0 from "./ChatImagePreview.vue?vue&type=style&index=0&id=287e0f14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287e0f14",
  null
  
)

export default component.exports